export function downloadBytes(data: any, filename: string, extesion: string): void {
  let dataType = data.type;
  let binaryData = [];
  binaryData.push(data);
  let downloadLink = document.createElement('a');
  downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
  downloadLink.setAttribute('download', `PEDIDO ${filename}.${extesion}`);
  document.body.appendChild(downloadLink);
  downloadLink.click();
}
